import React from "react";

export default function StatCard({
  icon,
  label,
  value,
  subvalue,
  tone = "slate",
}) {
  const tones = {
    slate: "bg-slate-50 text-slate-700 ring-slate-200",
    amber: "bg-amber-50 text-amber-700 ring-amber-200",
    emerald: "bg-emerald-50 text-emerald-700 ring-emerald-200",
    sky: "bg-sky-50 text-sky-700 ring-sky-200",
    rose: "bg-rose-50 text-rose-700 ring-rose-200",
  };

  return (
    <div className="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="text-sm font-medium text-slate-500">{label}</div>
          <div className="mt-2 text-2xl font-black tracking-tight text-slate-900">
            {value}
          </div>
          {subvalue ? (
            <div className="mt-1 text-xs text-slate-500">{subvalue}</div>
          ) : null}
        </div>

        <div
          className={`inline-flex h-12 w-12 items-center justify-center rounded-2xl ring-1 ${tones[tone] || tones.slate}`}
        >
          {icon}
        </div>
      </div>
    </div>
  );
}